import React, {Component, FC} from 'react';
import "./Loader.css"

interface ILoaderProps {
    overlay?: boolean
}

const Loader: FC<ILoaderProps> = ({overlay = true}) => {
    return (
        <div className={overlay ? 'global-loader-container-none_height': ''}>
            <div className={overlay ? 'global-loader-container': ''}>
                <div className="global-loader">

                </div>
            </div>
        </div>
    );
}

export default Loader;